import { ReportSyncResult } from "../../types/reporting.types";
import { alertMessage } from "../alert";

const SYNC_FAILURE_TITLE = "Some files could not be synced to SharePoint.";
const RETRY_HINT = "You can retry by saving the report again.";

/** Warn about attachment sync failures; returns true when a warning was shown. */
export const notifySyncFailures = (sync?: ReportSyncResult): boolean => {
	if (!sync?.hasFailures) return false;
	const details = sync.failedFiles
		?.map((file) => `${file.name} - ${file.reason}`)
		.join("\n");
	alertMessage(
		"warning",
		SYNC_FAILURE_TITLE,
		details ? `${details}\n\n${RETRY_HINT}` : RETRY_HINT
	);
	return true;
};

/** Show the success message unless attachments failed to sync. */
export const notifySyncResult = (
	sync: ReportSyncResult | undefined,
	successMessage: string
) => {
	if (!notifySyncFailures(sync)) {
		alertMessage("success", successMessage);
	}
};
